import { financialKeys } from './financial-api';
import { queryClient } from '@/lib/query-client';

const MONTHS = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

/** Rótulo curto de período: `2026-10` → `out/2026`; `2026-10-13` → `13/10`. */
export function periodLabel(period: string): string {
  const parts = period.split('-');
  if (parts.length === 2) return `${MONTHS[Number(parts[1]) - 1]}/${parts[0]}`;
  if (parts.length === 3) return `${parts[2]}/${parts[1]}`;
  return period;
}

/** Invalida consultas financeiras e o dashboard após qualquer mutação do módulo. */
export const invalidateFinancial = async () => {
  await queryClient.invalidateQueries({ queryKey: financialKeys.all });
  await queryClient.invalidateQueries({ queryKey: ['dashboard'] });
};
